var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.59061 12.2158C6.4698 12.0967 6.4698 11.9033 6.59061 11.7842L14.3981 4.08888C14.5184 3.97037 14.7129 3.97037 14.8331 4.08888L15.9094 5.14967C16.0302 5.26875 16.0302 5.46224 15.9094 5.58132L9.54308 11.8561C9.46254 11.9355 9.46254 12.0645 9.54308 12.1439L15.9094 18.4187C16.0302 18.5378 16.0302 18.7312 15.9094 18.8503L14.8331 19.9111C14.7129 20.0296 14.5184 20.0296 14.3981 19.9111L6.59061 12.2158Z",
    fill: "#F1F4F9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/leftArrow.e7379049ab68f249ad2152b964dec769.svg";
export { ForwardRef as ReactComponent };